<template>
  <div class="kye-editor-new-upload">
    <div class="kye-dialog-body">
      <kye-upload v-show="false"
                  :value="[]"
                  :disabled="fileList.length >= (limit || 10)"
                  :code="bizCode"
                  btn-text="上传"
                  style="float:left;"
                  btn-type="text"
                  :show-file-list="false"
                  @success="uploadSuccess"
                  ref="upload">
      </kye-upload>
      <div class="upload-new"
            onselectstart="return false;">
        <kye-button class="up-btn"
                    type="primary"
                    :disabled="fileList.length >= limit"
                    @click="tiggerUpload()">上传附件 ({{fileList.length }}/{{limit}})</kye-button>
        <p class="tips">请上传小于50MB的文件，支持excel,word,ppt,pdf,image(图片)，zip(压缩包)等格式</p>
      </div>
      <div v-for="(model) in fileList" :key="model.id">
        <span style="cursor: pointer"
              class="upload-item">
          <a @click="downloadFile(model.url)"
            class="upload-file-item-name"
            href="javascript:void(0);">
            <i class="iaa iaa-fujian"
              style="color:#4ECD97;"></i>
            {{model.name || '无文件名'}}
          </a>
          <div class="item-right">
            <a @click="downloadFile(model.url)"
              class="upload-file-item-download"
              href="javascript:void(0);">
              <img width="12"
                  src="../img/download.png" />
            </a>
            <a class="upload-file-item-remove"
              @click="remove(model)"
              href="javascript:void(0);">
              <i class="iconfont icon-delete"
                style="color:#8464EF; font-size: 14px"></i>
            </a>
          </div>
        </span>
      </div>
    </div>
    <div class="el-dialog__footer">
      <kye-button type="primary"
                  hotkey="ctrl+s"
                  @click="confirmFile">确认(S)</kye-button>
      <kye-button @click="$emit('close')">取消</kye-button>
    </div>
  </div>
</template>

<script>
  import mixins from 'public/mixins'
  export default {
    mixins: [mixins],
    props: {
      fileId: {
        type: String
      },
      bizCode: {
        type: String,
        default: ''
      },
      limit: {
        type: Number,
        default: 5
      },
    },
    data () {
      return {
        fileList: [],
      }
    },
    created () {

    },
    methods: {
      uploadSuccess (files, list) {
        this.fileList.push(files[0])
        this.$emit('uploadSuccess', this.fileList, list)
      },
      downloadFile (url) {
        window.erpOpen(url)
      },
      remove (file) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示').then(async () => {
          await this.$http('file.deleteByIds', {
            ids: [file.id],
          })
          this.spliceFile(file)
        }).catch((e) => {
          console.error('exception: ', e)
          throw e
        })
      },
      // 将文件从视图移除
      spliceFile (file) {
        let index = this.fileList.findIndex((item) => file.id === item.id)
        this.fileList.splice(index, 1)
      },
      tiggerUpload () {
        this.$refs.upload.manualUpload()
      },
      setFileList (fileList) {
        this.fileList = fileList
      },
      confirmFile () {
       this.$emit('close')
       this.$emit('uploadFile', this.fileList)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kye-editor-new-upload {
    .upload-new {
      color: #c9c8cc;
      cursor: pointer;
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      justify-content: center;
      // border: 1px dashed $color;
      border-radius: 2px;
      font-size: 12px;
      // height: 128px;
      margin-bottom: 8px;
      width: 100%;
      .up-btn {
        margin-bottom: 15px;
      }
      .iconfont,
      .iaa {
        color: #c9c8cc;
        font-size: 30px;
      }
      .title {
        margin: 12px 0 6px;
        color: var(--g-color-primary);
      }
      .tips {
        color: #999;
      }
    }
    .upload-item {
      position: relative;
      font-size: 12px;
      margin-right: 12px;
      margin-bottom: 6px;
      padding: 0 0 0 8px;
      // border: 1px solid #9571e9;
      height: 28px;
      line-height: 28px;
      vertical-align: top;
      background-color: #f7f7f7;
      border-radius: 2px;
      display: flex;
      border: 1px solid #f7f7f7;
      justify-content: space-between;
      align-items: center;
      // &:hover {
      //   background-color: rgba(149, 113, 233, 0.1);
      // }
      .upload-file-item-download,
      .upload-file-item-remove {
        visibility: hidden;
      }
      &:hover {
        border: 1px solid #9571e9;
        .upload-file-item-download,
        .upload-file-item-remove {
          visibility: inherit;
        }
      }
      a {
        margin-right: 8px;
        display: flex;
        align-items: center;
      }
      .upload-file-item-name {
        color: #333333;
        display: inline-block !important;
        width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: color 0.3s;
        white-space: nowrap;
      }
      .item-right {
        display: flex;
        align-items: center;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/public/components/kye-editor-new/components/upload-file.vue